import Vue from 'vue'

// 设置 格式化时间展示格式
/**
 * 格式化时间展示格式
 * 显示按时间长度显示，大于一小时的显示为 小时:分钟:秒
 * 显示时间最低到分钟，不满一分钟，分钟部分显示00
 */
Vue.filter('timeFormat', function (time) {
  let text = '00:00'
  if (!time || isNaN(Number(time))) {
    return text
  } else {
    const duration = Number(time)
    var hour = Math.floor(duration / 3600)
    var minute = Math.floor(duration / 60)
    if (minute < 10) {
      minute = '0' + minute
    }
    var second = Math.ceil(duration % 60)
    if (second < 10) {
      second = '0' + second
    }
    if (hour) {
      text = `${hour}:${minute}:${second}`
    } else {
      text = `${minute}:${second}`
    }
    return text
  }
})
